import { extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import ptBR from 'vee-validate/dist/locale/pt_BR'

// loop over all rules
for (let rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: ptBR.messages[rule] // add its message
  })
}

extend('password', {
  validate: (value, { other }) => value === other,
  message: 'A confirmação de senha está incorreta.',
  params: [{ name: 'other', isTarget: true }]
})

extend('verify_password', {
  message: field => `A senha deve conter entre 8 e 32 caracteres, sendo no mínimo 1 número e uma letra (maiúscula ou minúscula)`,
  validate: value => {
    let strongRegex = new RegExp('^(?=.*[aA-zZ])(?=.*[0-9])(?=.{8,32})')
    return strongRegex.test(value)
  }
})
